// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { string, boolean, number } from "@altostra/type-validations/lib/primitives";

export const isEngagementLinkTemplatesResult = objectOf({
  results: arrayOf(
    objectOf({
      id: string,
      name: string,
      description: string,
      prepend: maybe(string),
      tag_names: arrayOf(string),
      territory_ids: arrayOf(string),
      context_property_tags: arrayOf(string),
      key_value_pairs: arrayOf(
        objectOf({
          id: string,
          key: string,
          value: string,
          custom_value: boolean,
        })
      ),
      last_edited_at: number,
      created_by: arrayOf(string),
      last_edited_by: arrayOf(string),
    })
  ),
});
